
/**
 * - Use `plyr` from npm
 * - Remove exports-loader
 * - Load SVG-Sprite via iconUrl = require('file!assets/sprite.svg')
 */

var template = require('./video-modal.html')
var sprite = require('raw-loader!assets/sprite.svg')

module.exports = {
  created: function() {
  },
  mounted: function() {
    var plyr = require('plyr');
    this._players = plyr.setup({html: require('./controls.html'), iconUrl: sprite});
  },
  template: template,
  components: {
    'plyr-sprite': { template: sprite }
  },
  methods: {
    close() {
      this._players[0].destroy()
    }
  }
}



// WEBPACK FOOTER //
// ./lib/runeset-view/video-modal.js